<template>
  <div class="elr-col-full tab-section-header">
    <SectionSubheading>All My Little Ponies</SectionSubheading>
    <SectionHeading>All Generations</SectionHeading>
  </div>
</template>

<script>
import SectionHeading from '../SectionHeading/SectionHeading';
import SectionSubheading from '../SectionSubheading/SectionSubheading';

export default {
  name: 'TabsHeader',
  components: {
    SectionHeading,
    SectionSubheading
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.tab-section-header {
  padding-bottom: 50px;

  &::after {
    margin: auto;
    position: relative;
    top: 10px;
  }
}
</style>
